import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { FooterComponentProps, FooterComponentState } from './footercomponent';
import { FooterCSSStyle } from './footercss';
import * as React from 'react';
import './footer-style.css';
import { Strings } from '../../../utils/resources/strings';
import { RoutingFeatures } from '../../components/navigation/routingfeature';

export class FooterViewImpl extends UIComponentViewImpl<UIDataModel>
{
   
    bindHandlers()
    {
        this.onFaqClicked = this.onFaqClicked.bind(this);
        this.onTermsandConditionClicked = this.onTermsandConditionClicked.bind(this);
        this.onMTNHomeClicked = this.onMTNHomeClicked.bind(this);
       
    }
    draw(props: FooterComponentProps, state: FooterComponentState, cssStyle: FooterCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
        let pathname = props.context.getRouterHistory().location.pathname;
        let currenPageName = pathname.substring(pathname.lastIndexOf('/') + 1);
        return(
                    <footer id="crbt-portal-footer" style={cssStyle.getWrapperCSSStyle()}>
                        <div style={cssStyle.getNavBlockMainWrapperCSSStyle()}>
                            
                            <div style={cssStyle.getNavBlockWrapperCSSStyle()}>
                                <ul style={cssStyle.getUnorderListCSSStyle()}>
                                        <li key={0} style={cssStyle.getListItemCSSStyle(currenPageName)}>
                                            <div onClick={currenPageName !== RoutingFeatures.FAQ ? this.onFaqClicked : () =>{}} style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.faq)}</div>
                                        </li>
                                        {false && <li key={0} style={cssStyle.getListItemCSSStyle(currenPageName)}>
                                            <div onClick={currenPageName !== RoutingFeatures.TERMS_AND_CONDITION ? this.onTermsandConditionClicked : () =>{}} style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.terms_condition)}</div>
                                        </li>}
                                        <li key={0} style={cssStyle.getListItemCSSStyle(currenPageName)}>
                                            <div onClick={currenPageName !== RoutingFeatures.HOME ? this.onMTNHomeClicked : () =>{}} style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.mtn_home)}</div>
                                       </li>
                                      
                                </ul>
                            </div>
                           
                        </div>
                        <div id="footer-line-div" style={{width: '100%'}}>
                            <div style={cssStyle.getLineCSSStyle()}/>
                        </div>
                        <div style={cssStyle.getCopyrightWrapperCSSStyle()}>
                            <label  style={cssStyle.getCopyrightTextCSSStyle()}>
                            {props.context.getResources().getString(Strings.copyright)}</label>
                        </div>

                    </footer>
                    
        );
    }

    onFaqClicked()
    {
        (this.getUIProps() as FooterComponentProps).onFaqClicked();
    }
    onTermsandConditionClicked()
    {
        (this.getUIProps() as FooterComponentProps).onTermsandConditionClicked();
    }
    onMTNHomeClicked()
    {
        (this.getUIProps() as FooterComponentProps).onMTNHomeClicked();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/footer-native/footerview.tsx